var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 95,
    viewBox: "0 0 151 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8332 14.087C50.5719 10.2271 44.3153 11.7871 43.2479 16.7262L37.4177 43.7039C37.1328 45.0221 36.2196 46.1127 34.9776 46.6219L9.50438 57.0661C4.83649 58.9799 4.39848 65.4253 8.74925 67.9738L32.5407 81.9096C33.7024 82.5901 34.4577 83.8005 34.5589 85.1469L36.6286 112.685C37.0069 117.718 42.9822 120.154 46.7477 116.786L67.2818 98.4212C68.2835 97.5254 69.661 97.1819 70.9659 97.5027L97.7183 104.078C102.624 105.283 106.756 100.327 104.727 95.7056L93.6266 70.4197C93.0839 69.1834 93.1825 67.76 93.8888 66.6138L108.353 43.1398C110.998 38.847 107.585 33.3618 102.565 33.8634L75.1706 36.6007C73.8348 36.7341 72.5166 36.1999 71.6462 35.1698L53.8332 14.087Z",
    fill: "#013583",
    stroke: "#054FA5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.579 5.86327C129.832 3.82764 127.082 3.53862 125.929 5.3746L121.281 12.7745C121.173 12.9465 120.99 13.0516 120.793 13.0595L112.103 13.4111C109.938 13.4986 108.828 16.0339 110.199 17.6939L115.754 24.418C115.883 24.5731 115.928 24.7837 115.872 24.9809L113.509 33.4027C112.927 35.4768 114.964 37.3482 116.983 36.5377L125.064 33.2935C125.248 33.2197 125.456 33.2415 125.62 33.352L132.85 38.2054C134.657 39.418 137.038 38.011 136.9 35.8612L136.339 27.1321C136.326 26.9276 136.414 26.731 136.572 26.606L143.404 21.1838C145.09 19.8452 144.531 17.1345 142.432 16.5988L134.005 14.4481C133.814 14.3994 133.656 14.2585 133.586 14.0678L130.579 5.86327Z",
    fill: "#013583",
    stroke: "#054FA5",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.98 72.9757L141.03 72.6645L141.98 72.9757C141.987 72.9536 142.005 72.937 142.027 72.9305L147.625 71.3118C149.292 70.8299 149.649 68.6566 148.27 67.6428L143.553 64.1752C143.53 64.158 143.518 64.1311 143.518 64.1053L143.677 58.2703C143.724 56.5591 141.788 55.5113 140.385 56.5182L135.657 59.9136C135.639 59.9266 135.614 59.9314 135.588 59.922L130.088 57.9346C128.465 57.348 126.88 58.8779 127.41 60.5205L129.204 66.0866C129.213 66.1128 129.207 66.1382 129.193 66.1558L125.635 70.7625C124.58 72.1285 125.56 74.1005 127.271 74.1136L127.279 73.1136L127.271 74.1136L133.108 74.1582C133.134 74.1584 133.161 74.1717 133.177 74.1957L136.478 79.0302C137.443 80.4437 139.627 80.163 140.167 78.5142L141.98 72.9757Z",
    fill: "#013583",
    stroke: "#054FA5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 10.5,
    r: 3.5,
    fill: "#0077AA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 42.5,
    r: 2.5,
    fill: "#0077AA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 76,
    r: 2,
    fill: "#50AADE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 85,
    r: 1,
    fill: "#50AADE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.edb77fa11fd9945a189d737439286ddb.svg";
export { ForwardRef as ReactComponent };